import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import LuxPlusLabel from 'LuxKit/Label/LuxPlusLabel'
import type { ModalFooterOnClickHandler } from 'LuxKit/Modal/ModalFooter'
import LuxPlusLabelWithModal from 'luxPlus/components/LuxPlusLabelWithModal'
import useLuxPlusLandingActions from 'luxPlus/hooks/useLuxPlusLandingActions'

const MEMBER_PRICE_OFFER_CRUISE_TYPE = 'member-price-offer-cruise' as const

export type CruiseLuxPlusLabelProps = {
  isModalEnabled?: boolean
  offer?: App.CruiseOffer
}

function CruiseLuxPlusLabel({ isModalEnabled = true, offer }: CruiseLuxPlusLabelProps) {
  const intl = useIntl()
  const { handleBecomeMember } = useLuxPlusLandingActions()

  const handleJoinLuxPlusMembership = useCallback<ModalFooterOnClickHandler>(
    (_e, resolve) => {
      resolve()
      handleBecomeMember()
    },
    [handleBecomeMember],
  )

  if (isModalEnabled) {
    return (
      <LuxPlusLabelWithModal
        type={MEMBER_PRICE_OFFER_CRUISE_TYPE}
        offer={offer}
        hideSpecialLabel
        primaryActionText={intl.formatMessage({
          id: 'UzhEm0puAIDh0IlibYoA',
          defaultMessage: 'Join now',
          description: 'Primary action button text to join LuxPlus+ membership from the cruise overview pane',
        })}
        onPrimaryActionClick={handleJoinLuxPlusMembership}
      />
    )
  }

  return <LuxPlusLabel type={MEMBER_PRICE_OFFER_CRUISE_TYPE} />
}

export default CruiseLuxPlusLabel
